import { render, staticRenderFns } from "./goodsPortrait.vue?vue&type=template&id=3bd367a0&scoped=true&"
import script from "./goodsPortrait.vue?vue&type=script&lang=js&"
export * from "./goodsPortrait.vue?vue&type=script&lang=js&"
import style0 from "./goodsPortrait.vue?vue&type=style&index=0&id=3bd367a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd367a0",
  null
  
)

component.options.__file = "goodsPortrait.vue"
export default component.exports